import carousel from '../api/carousel' // 轮播图接口
import industries from '../api/industries' //首页产品接口
import sustainability from '../api/sustainability' //sustainability接口
import caselist from '../api/case' //案例接口

// technology接口
import tecsolutions from '../api/technologySolutions'
import composite from '../api/composite'
import injectionMolding from '../api/injectionMolding'
import material from '../api/material'
import forming from '../api/forming'
import surface from '../api/surface'

// industries接口
import expertise from '../api/expertise'

// services 接口
import capabilities from '../api/capabilities'
import moldingTrials from '../api/moldingTrials'

// EngingeeringConsultiong 接口
import engcon from '../api/engcon'

// news 接口
import news from '../api/news'

// contactUs
import SendMailAddress from '../api/contactUs'

export default{
    carousel,
    industries,
    sustainability,
    caselist,
    tecsolutions,
    composite,
    injectionMolding,
    material,
    forming,
    surface,
    expertise,
    capabilities,
    engcon,
    news,
    moldingTrials,
    SendMailAddress
}


// WEBPACK FOOTER //
// ./src/utils/index.js